module.exports = __webpack_public_path__ + "static/skn-passport-eec7a9fb99c7bdaf4967de57153d2bb8.png";